import { render, staticRenderFns } from "./question-paper.vue?vue&type=template&id=74f549ac&scoped=true"
import script from "./question-paper.vue?vue&type=script&lang=ts"
export * from "./question-paper.vue?vue&type=script&lang=ts"
import style0 from "./question-paper.vue?vue&type=style&index=0&id=74f549ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f549ac",
  null
  
)

export default component.exports